/* global document */
import React, { Fragment, useEffect } from 'react';
import { useSelector } from 'react-redux';

const DummyOff = () => {
  const { isDummy } = useSelector(state => state.mleReducer);
  const dummy = document.querySelector('.dummy-placeholder');

  useEffect(() => {
    if (dummy) {
      dummy.style.display = isDummy ? 'block' : 'none';
    }
  }, [isDummy]);

  return <Fragment />;
};

export default DummyOff;
